import {
  SurfaceDocument,
  SurfaceQuery,
  SurfaceQueryVariables,
  SurfaceRefFragment,
  SurfaceRefFragmentDoc,
  withStandardRefSuspenseHook,
} from '@spotify/confidence-graphql';

export const useSurfaceRefSuspense = withStandardRefSuspenseHook<
  SurfaceQuery,
  SurfaceRefFragment,
  'surface',
  SurfaceQueryVariables
>(
  SurfaceDocument,
  'surface',
  SurfaceRefFragmentDoc,
  'SurfaceRef',
  'WorkflowV1Surface',
);
